import {Provider} from '/src/parents/provider'

class ConciliationProvider extends Provider {
  findById(id) {
    return this.doRequest('GET', `${process.env.VUE_APP_API_URL}/v1/conciliation/${id}`)
  }
}

export default new ConciliationProvider()
